import { useIsClient } from "@thelabnyc/thelabui/src/hooks/layout";

import { DEFAULT_VIEWPORT, IViewport } from "../../models/screen";
import { useAppSelector } from "../reducers";

/** Use the SSR viewport until this consumer hydrates, then follow Redux. */
export const useViewport = (): IViewport => {
    const viewport = useAppSelector((state) => state.common.viewport);
    const isHydrated = useIsClient();
    return isHydrated ? viewport : DEFAULT_VIEWPORT;
};
